"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _functions = require("../../../functions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarContainer = function (_Component) {
    _inherits(CalendarContainer, _Component);

    function CalendarContainer(props) {
        _classCallCheck(this, CalendarContainer);

        var _this = _possibleConstructorReturn(this, (CalendarContainer.__proto__ || Object.getPrototypeOf(CalendarContainer)).call(this, props));

        _this.renderCalendar = function () {
            return _react2.default.createElement(
                "div",
                { style: { zIndex: 10000 } },
                _react2.default.createElement(
                    "style",
                    null,
                    ".showInFront{z-index:1000};"
                ),
                _this.props.children
            );
        };

        _this.render = function () {
            if ((0, _functions.isBrowser)()) {
                return _reactDom2.default.createPortal(_this.renderCalendar(), _this.el);
            } else {
                return null;
            }
        };

        if ((0, _functions.isBrowser)()) {
            _this.el = document.createElement("div");
        }
        return _this;
    }

    _createClass(CalendarContainer, [{
        key: "componentWillMount",
        value: function componentWillMount() {
            // Lock body scroll if is visible
            if ((0, _functions.isBrowser)()) {
                try {
                    var bodyElement = document.getElementsByTagName("BODY")[0];
                    bodyElement.appendChild(this.el);
                } catch (err) {}
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            // Lock body scroll if is visible
            if ((0, _functions.isBrowser)()) {
                try {
                    var bodyElement = document.getElementsByTagName("BODY")[0];

                    bodyElement.removeChild(this.el);
                } catch (err) {}
            }
        }
    }]);

    return CalendarContainer;
}(_react.Component);

exports.default = CalendarContainer;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/datePicker/CalendarContainer.js
// module id = 999
// module chunks = 95715928098905 168707334958949